// utils/normalizePhone.js

/**
 * 905xxxxxxxx formatında normalize eder.
 * + işaretini tamamen kaldırır.
 * Başındaki 00 varsa onu da temizler.
 */

export function normalizePhone(raw = "") {
  if (!raw) return "";

  let phone = String(raw).trim();

  // + işaretini kaldır
  phone = phone.replace(/^\+/, "");

  // 00 ile başlayanlar → 00 kaldır
  phone = phone.replace(/^00/, "");

  // Sadece rakam bırak
  phone = phone.replace(/\D/g, "");

  // Minimum uzunluk kontrolü (10–15 hane)
  if (phone.length < 10 || phone.length > 15) {
    return ""; // geçersiz → caller hata versin
  }

  return phone;
}

/**
 * E.164 geçerlilik kontrolü
 */
export function isValidE164(raw = "") {
  const cleaned = normalizePhone(raw);
  return cleaned.length >= 10 && cleaned.length <= 15;
}
